
import _ from 'lodash';
import { ERROR_CHANGE_DESIGN, ERROR_WRONG_INFORMATIONS, SUCCESS_UPDATE_TEXT } from '../../constants';
import { showNotification } from '../../components/Notification/Notification.view';
import { updateConfigurationActivation } from '../../apis/backend'


export const handleChange = ({ target }, validationMessage, setValidationMessage) => {
  const { id, value } = target;

  let statusError = 'is-invalid';

  statusError = value !== null && value !== '' ? 'is-valid' : 'is-invalid';
  setValidationMessage({
    ...validationMessage,
    [id]: { ...validationMessage[id], text: statusError }
  });
};

export const changeActivation = async (
  openErrorModal,
  stateObj,
  setStateObj,
  validationMessage
) => {
  const { enabled, message, title, offset } = stateObj;
  try {
    setStateObj({ isLoading: true });
    if (
      _.find(validationMessage, input => input && input.text === 'is-invalid')

    )
      openErrorModal(ERROR_WRONG_INFORMATIONS);
    else {
      await updateConfigurationActivation({ enabled, message, title, offset })
      showNotification(
        'light',
        'ltr',
        'primary',
        SUCCESS_UPDATE_TEXT,
        `Les paramétres d'activation ont bien été modifiés.`
      );
      setStateObj({ isLoading: false });
    }

  } catch (e) {
    openErrorModal(ERROR_CHANGE_DESIGN);
  }
  setStateObj({ isLoading: false });
};
